<div class="d-flex flex-row h-100">
  <div style="width: 33%">
    <dx-list
      [dataSource]="dataSource"
      [selectedItemKeys]="selectedItemKeys"
      selectionMode="single"
      displayExpr="name"
      keyExpr="name"
      [grouped]="true"
      [collapsibleGroups]="true"
      [searchEnabled]="true"
      [searchExpr]="['name', 'descLong', 'descShort']"
      (onContentReady)="onContentReady($event)"
      (onSelectionChanged)="onSelectionChanged($event)"
      [(searchValue)]="searchValue"
      [ngStyle]="{ visibility: accordionVisible }"
    >
      <div *dxTemplate="let item of 'group'">
        <div>{{ item.key | translate }}</div>
      </div>
      <div *dxTemplate="let item of 'item'">
        <div>{{ item.name + 'Short' | translate }}</div>
      </div>
    </dx-list>
  </div>
  <div style="width: 67%; border: lightgray; border-left: outset; display: flex; flex-direction: column">
    <dx-scroll-view showScrollbar="always" id="target" style="margin-left: 5%">
      <div *ngIf="selectedItem != null">
        <div
          class="dx-fieldset-header"
          [style.display]="'flex'"
          [style.justify-content]="'space-between'"
          [style.align-items]="'center'"
        >
          <div>{{ selectedItem.descShort }}</div>
          <dx-button *ngIf="selectedItem?.wikiUrl && selectedItem?.wikiUrl != ''" icon="description" text="{{ 'Wiki' | translate }}" stylingMode="text" type="default"   (onClick)="openWikiUrl()"/>
        </div>
        <div class="dx-field">
          <ng-container *ngFor="let tag of selectedItem?.groups ?? []">
            <span
              class="badge bg-primary me-1"
              style="font-size: 0.8rem; background-color: var(--dx-color-primary) !important"
            >
              {{ tag | translate }}
            </span>
          </ng-container>
        </div>

        <div class="dx-field" style="width: 100% !important">
          <div class="dx-field-label" style="width: 100%; white-space: pre-wrap">{{ selectedItem.descLong }}</div>
        </div>

        <div *ngIf="selectedItem.isDelete" class="dx-field accordion-body-warning">
          {{
            'ACHTUNG: Diese Makro löscht Daten unwiderruflich. Bitte erstellen Sie ggf. einen Wiederherstellungspunkt.'
              | translate
          }}
        </div>

        <div *ngIf="isFeatureSystemMakro()" class="dx-field">
          {{
            'Merkmalsgruppen, die als Vorlage im Katalog hinterlegt sind können mit diesem Makro nicht bearbeitet werden.'
              | translate
          }}
        </div>

        <div [ngSwitch]="selectedItem.name">
          <userAction-convertPictures *ngSwitchCase="'ResizeImages'" />
          <userAction-deleteByList *ngSwitchCase="'DeleteByList'" />
          <userAction-searchByList *ngSwitchCase="'SearchByListJob'" />
          <userAction-updateCatalog *ngSwitchCase="'UpdateFromCatalog'" />
          <userAction-updateToCatalog *ngSwitchCase="'UpdateToCatalog'" />
          <userAction-compareCatalog *ngSwitchCase="'CompareCatalog'" />
          <userAction-renameFeatureSystem *ngSwitchCase="'RenameFeatureSystem'" />
          <userAction-deleteEmptyFeatures *ngSwitchCase="'DeleteEmptyFeatures'" />
          <userAction-generateAITexts *ngSwitchCase="'MassGenerateKITexts'" />
          <userAction-renameFeatures *ngSwitchCase="'RenameFeatures'" />
          <userAction-splitFeatureValuesFromUnit *ngSwitchCase="'SplitFeatureValuesFromUnit'" />
          <userAction-deleteFeatureSystems *ngSwitchCase="'DeleteFeatureSystems'" />
          <userAction-copyMediaFromOtherCatalog *ngSwitchCase="'CopyMediaFromOtherCatalog'" />
          <userAction-deleteFeatures *ngSwitchCase="'DeleteFeatures'" />
          <userAction-createTechnicalDetails *ngSwitchCase="'CreateTechnicalDetails'" />

          <!--55 SpreadCatalog-->
          <userAction-spreadCatalog *ngSwitchCase="'SpreadCatalog'" />

          <userAction-harmonizeFeatureSystems *ngSwitchCase="'HarmonizeFeatureSystems'" />
          <userAction-fixClassification *ngSwitchCase="'FixClassification'" />
          <useraction-createUniqueGroupIds *ngSwitchCase="'CreateUniqueGroupId'" />
          <userAction-exportReportProductDatasheet *ngSwitchCase="'ExportReportProductDatasheet'" />
          <userAction-deleteDuplicateMimes *ngSwitchCase="'DeleteDuplicateMimes'" />
          <userAction-removeUdxOnProducts *ngSwitchCase="'RemoveUDXOnProduct'" />
          <userAction-deleteMediaByPurpose *ngSwitchCase="'DeleteMediaByPurpose'" />

          <userAction-CreateVariants *ngSwitchCase="'CreateOrMarkVariantsFeatures'" />
          <userAction-harmonizeFeatures *ngSwitchCase="'HarmonizeFeatures'" />
          <useraction-flatten-category-tree *ngSwitchCase="'FlattenCategoryTree'" />
          <userAction-setWawiSupplierPids *ngSwitchCase="'SetWawiSupplierPids'" />
          <userAction-createEnventaMime *ngSwitchCase="'CreateEnventaMime'" />
          <userAction-setMimePurpose *ngSwitchCase="'SetMimePurpose'" />
          <userAction-markAsChanged *ngSwitchCase="'MarkAsChanged'" />
          <useraction-changemimepurposes *ngSwitchCase="'ChangeMimePurposes'" />
          <useraction-convert-orderdetails-to-supplierdetails *ngSwitchCase="'ConvertOrderDetailsToSupplierDetails'" />
          <userAction-applyWawiMappings *ngSwitchCase="'ApplyWawiMappings'" />
          <app-useraction-assign-mime-by-supplier-pid *ngSwitchCase="'AssignMimeBySupplierPid'" />
          <userAction-categoriesToMasters *ngSwitchCase="'CategoriesToMasters'" />
          <userActionRemoveDeadReferences *ngSwitchCase="'RemoveDeadReferences'" />
          <userAction-removeValuelists *ngSwitchCase="'RemoveValueLists'" />
        </div>
      </div>
      <div class="macroHead dx-accordion-item-body" *ngIf="startMacroButtonEnabled"></div>
    </dx-scroll-view>

    <dx-button
      *ngIf="selectedItem && !editMode"
      style="align-self: flex-end"
      stylingMode="text"
      type="default"
      text="{{ 'Starte Makro' | translate }}"
      (onClick)="startMacro()"
      class="buttonMargin"
    />

    <dx-button
      *ngIf="selectedItem && editMode"
      style="align-self: flex-end"
      stylingMode="text"
      type="default"
      text="{{ 'Speichern' | translate }}"
      (onClick)="saveMacro()"
      class="buttonMargin"
    />
  </div>
</div>
